import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/translationContext";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import ClockIcon from "@heroicons/react/24/solid/ClockIcon";

interface props {
  datas: {
    hours: {
      d_1_1?: string;
      d_1_2?: string;
      d_2_1?: string;
      d_2_2?: string;
      d_3_1?: string;
      d_3_2?: string;
      d_4_1?: string;
      d_4_2?: string;
      d_5_1?: string;
      d_5_2?: string;
      d_6_1?: string;
      d_6_2?: string;
      d_7_1?: string;
      d_7_2?: string;
    };
  };
}

export default function WorkingHours(props: props) {
  const { t } = useTranslation();
  if (!Object.keys(props.datas?.hours)?.length) return null;

  const days = [
    { name: t("calendar-day-monday"), number: 1 },
    { name: t("calendar-day-tuesday"), number: 2 },
    { name: t("calendar-day-wednesday"), number: 3 },
    { name: t("calendar-day-thursday"), number: 4 },
    { name: t("calendar-day-friday"), number: 5 },
    { name: t("calendar-day-saturday"), number: 6 },
    { name: t("calendar-day-sunday"), number: 7 },
  ];

  const currentDay = new Date().getDay();
  const todayNumber = days.find((day) => day.number === currentDay);

  return (
    <div
      id={VENUE_TABS.WORKING_HOURS}
      className="flex flex-col border border-gray p-4  rounded-[32px] gap-4 lg:max-w-[863px] mt-6"
    >
      <div className="flex bg-stone-50 rounded-[16px] py-1.5 px-2">
        <div className="flex items-center gap-2 ">
          <ClockIcon className="size-5 text-primary" />
          <h2 className="font-bold text-sm">
            Çalışma Saatleri
          </h2>
        </div>
      </div>

      <div className="flex flex-col">
        {days.map((day, index) => {
          const d1 = `d_${index + 1}_1` as
            | "d_1_1"
            | "d_1_2"
            | "d_2_1"
            | "d_2_2"
            | "d_3_1"
            | "d_3_2"
            | "d_4_1"
            | "d_4_2"
            | "d_5_1"
            | "d_5_2"
            | "d_6_1"
            | "d_6_2"
            | "d_7_1"
            | "d_7_2";
          const d2 = `d_${index + 1}_2` as
            | "d_1_1"
            | "d_1_2"
            | "d_2_1"
            | "d_2_2"
            | "d_3_1"
            | "d_3_2"
            | "d_4_1"
            | "d_4_2"
            | "d_5_1"
            | "d_5_2"
            | "d_6_1"
            | "d_6_2"
            | "d_7_1"
            | "d_7_2";

          const openingAt = props.datas.hours?.[d1];
          const closingAt = props.datas.hours?.[d2];

          const isToday = day.number === todayNumber?.number;
          const isClosed = openingAt === "23:23" && closingAt === "23:23";

          return (
            <div
              key={index}
              className={cn(
                "px-2 py-1 flex justify-between text-sm font-medium rounded-lg",
                isToday ? "text-secondary" : "test-assistant",
                index % 2 === 1 ? "bg-gray-secondary" : "",
              )}
            >
              <span>{day.name}</span>
              <span className="min-w-[92.97px] flex items-start">
                {isClosed
                  ? "KAPALI"
                  : openingAt && closingAt
                    ? `${openingAt} - ${closingAt}`
                    : "KAPALI"}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
